module.exports = __webpack_public_path__ + "static/img/security-img.be29828.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/keyFeaturesPhone/security-img.png
// module id = Glnf
// module chunks = 0